import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
const InlineForm = (submitTitle = void 0) => {
  const InlineFormInner = ({ children, disabled = false, onCancel, onSubmitForm }, ref) => {
    const { t } = useTranslation("widgets");
    const onSubmit = (event) => {
      event.stopPropagation();
      const { target: formDOMNode } = event;
      if (typeof formDOMNode.checkValidity === "function" && !formDOMNode.checkValidity()) {
        event.preventDefault();
        return;
      }
      if (typeof onSubmitForm === "function") {
        event.preventDefault();
        onSubmitForm(event);
      }
    };
    return /* @__PURE__ */ React.createElement("form", { onSubmit, ref }, children, /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary", disabled }, submitTitle != null ? submitTitle : t("message_table.decorators.create")), " ", /* @__PURE__ */ React.createElement(Button, { type: "button", disabled, onClick: onCancel }, t("actions.cancel", { ns: "common" })));
  };
  return React.forwardRef(InlineFormInner);
};
export default InlineForm;
